export default "__VITE_ASSET__CqRW2UuE__"